import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-762894078__a)" }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M16.234 14.027a9.788 9.788 0 0 1-.968 1.74c-.508.726-.925 1.228-1.246 1.507-.498.458-1.031.692-1.602.706-.41 0-.905-.117-1.48-.354-.578-.235-1.108-.352-1.594-.352-.509 0-1.054.117-1.638.352-.585.237-1.056.36-1.416.372-.547.024-1.093-.217-1.638-.724-.348-.303-.783-.823-1.304-1.56-.56-.787-1.019-1.699-1.379-2.739-.386-1.123-.579-2.21-.579-3.264 0-1.206.26-2.247.783-3.118.41-.7.956-1.253 1.64-1.659a4.41 4.41 0 0 1 2.216-.625c.435 0 1.005.134 1.714.399.707.265 1.16.4 1.36.4.148 0 .653-.158 1.507-.471.809-.291 1.49-.412 2.05-.364 1.514.122 2.652.72 3.409 1.795-1.355.82-2.025 1.97-2.011 3.444.012 1.149.428 2.104 1.247 2.863a4.1 4.1 0 0 0 1.247.818c-.1.29-.206.568-.318.835ZM12.761.36c0 .9-.329 1.74-.984 2.519-.792.925-1.748 1.46-2.786 1.375a2.8 2.8 0 0 1-.021-.341c0-.865.376-1.79 1.044-2.546a4.022 4.022 0 0 1 1.273-.955c.513-.25.998-.388 1.455-.412.013.12.019.24.019.36Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-762894078__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M1.391 0h15.162v18H1.391z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }